<script setup lang="ts">
definePageMeta({
  layout: 'blank',
  public: true,
})

const router = useRouter()
const { loggedIn, fetch } = useUserSession()

const ready = useTimeout(2000)

watch(
  [loggedIn, ready],
  ([isLoggedIn, isReady]) => {
    if (isLoggedIn) {
      router.replace('/dashboard')
      return
    }

    fetch()

    if (isReady) {
      router.replace('/welcome')
    }
  },
  {
    immediate: true,
  },
)
</script>

<template>
  <div class="relative h-screen w-full">
    <UContainer class="flex h-full flex-col items-center justify-center">
      <RialticLogo class="h-40 w-40 animate-pulse" icon />
    </UContainer>
  </div>
</template>
